import IPathModel from 'Models/PathModel'
import HomePaths from './HomePaths'
import HomePage from 'Application/Home/Pages';

const HomeRoutes: IPathModel[] = [
  {
    path: HomePaths.Home,
    element: HomePage
  }
]

export default HomeRoutes